// Helper function to validate password
// export const validatePassword = (password: any) => {
//   return password.length >= 6; // Assuming password should have at least 6 characters
// };

export const validatePassword = (password: string): boolean => {
  // Regular expression for:
  // - At least one uppercase letter
  // - At least one lowercase letter
  // - At least one digit
  // - At least one special character
  // - Minimum length of 8 characters
  const regex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  return regex.test(password);
};
